export class CreateDlsgPolicyResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "dlsgPolicy",
            "baseName": "dlsgPolicy",
            "type": "DlsgPolicy",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateDlsgPolicyResponse.attributeTypeMap;
    }
    constructor() {
    }
}
